import React from 'react';
import CustomImage from '../../../components/custom-image';

const SkillingYouth = () => {
  return (
    <div className="accordion-body">
      <div className="sd-content">
          <div className="left">
            <div className="blue-box">
              <p className="feature-title"><strong>Key Features</strong></p>
              <div className="sd-column">
                <div className="left">
                  <p className="feature-subtitle">More than</p>
                  <p className="bold-text blue-text">10</p>
                  <p className="feature-benifit">initiatives across our Group companies</p>
                </div>
                <div className="right">
                  <p className="feature-subtitle">More than</p>
                  <p className="bold-text blue-text">3,900</p>
                  <p className="feature-benifit">youth trained</p>
                </div>
              </div>
              
            </div>
            <div className="bottom-content">
              <p><strong>Types of Interventions</strong></p>
              <p>
              Sewing centres; Vocational training centres; Technical & computer literacy programmes; Traditional crafts and painting training
              </p>
            </div>
          </div>
          <div className="right">
            <div className="img-wrapper">
              <CustomImage className="custom-image" imageName="skill-youth.jpg" alt="Skilling Youth" maxWidth="768" />
            </div>
          </div>
      </div>
    </div>
  );
};

export default SkillingYouth;
